import type { CSSProperties } from 'react';
import {
  NOVA_DIMENSIONAL,
  NOVA_FLAT,
  toAssetSrc,
  type NovaMoodName,
} from './nova-assets';

export type { NovaMoodName } from './nova-assets';

export interface NovaMoodProps {
  mood?: NovaMoodName;
  flat?: boolean;
  size?: number;
  style?: CSSProperties;
  className?: string;
}

/** Web twin of NovaMood.tsx: a decorative, static image (`alt=""`, aria-hidden). */
export function NovaMood({
  mood = 'calm',
  flat = false,
  size = 96,
  style,
  className,
}: NovaMoodProps) {
  return (
    <img
      src={toAssetSrc((flat ? NOVA_FLAT : NOVA_DIMENSIONAL)[mood])}
      alt=""
      aria-hidden
      width={size}
      height={size}
      decoding="async"
      draggable={false}
      className={className}
      style={{ display: 'block', width: size, height: size, objectFit: 'contain', ...style }}
    />
  );
}
